import { useState } from 'owa-react';
import { upNextRoot } from './getExtraTopRibbonControlsAfterTabs.scss';
import type { IButtonStyles } from '@fluentui/react';
import { UpNextV2 } from 'owa-upnext-v2';
import React from 'react';
import { MonarchWin32Toggle, lazyIsToggleEnabled } from 'native-newoutlook-toggle';
import { observer } from 'owa-mobx-react';
import { owaComputedFn } from 'owa-computed-fn';
import { isSafeModeSession } from 'owa-config/lib/isSafeModeSession';
import { isRecoveryModeSession } from 'owa-config/lib/isRecoveryModeSession';
import { SafeMode, RecoveryMode } from './getModeContainerComponents';
import { AutoToggleTeachingCallout } from 'native-newoutlook-teaching-callout';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

const upNextStyles: IButtonStyles = {
    root: upNextRoot,
};

const ExtraTopRibbonControlsAfterTabs = observer(function ExtraTopRibbonControlsAfterTabs() {
    const [toggleEnabled, setToggleEnabled] = useState(false);
    React.useEffect(() => {
        const loadToggleEnabled = async () => {
            setToggleEnabled(await lazyIsToggleEnabled.importAndExecute());
        };
        loadToggleEnabled();
    }, []);

    const safeMode = isSafeModeSession();
    const recoveryMode = isRecoveryModeSession();
    const toggleRef = React.createRef<HTMLDivElement>();
    const autoToggleLightningId = 'AutoToggleTeachingCallout';

    return (
        <>
            {safeMode ? <SafeMode /> : recoveryMode ? <RecoveryMode /> : null}

            <UpNextV2
                containerStyle={upNextStyles}
                key="UpNextV2_ExtraTopRibbonControlsAfterTabs"
            />

            {toggleEnabled && (
                <div ref={toggleRef}>
                    <MonarchWin32Toggle />
                    {isGlobalFeatureEnabled('mail-auto-toggle-teaching-callout') && (
                        <AutoToggleTeachingCallout target={toggleRef} id={autoToggleLightningId} />
                    )}
                </div>
            )}
        </>
    );
}, 'ExtraTopRibbonControlsAfterTabs');

export const getExtraTopRibbonControlsAfterTabs: () => JSX.Element = owaComputedFn(
    function getExtraTopRibbonControlsAfterTabs(): JSX.Element {
        return <ExtraTopRibbonControlsAfterTabs />;
    }
);
